import * as React from 'react'
import {createBrowserRouter, RouterProvider} from 'react-router'

import {routes} from '@frontrow/console/src/routers/app-routes'

const router = createBrowserRouter(routes)

export default function AppRouter(): React.ReactElement {
  return <RouterProvider router={router} />
}
